//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useEffect, useState, useContext, useCallback } from "react";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";


// custom pages
import Context from "context/context";
import { Styles } from "./styles";
import settingsApi from "apis/settings/settings";
import AuditAPI from "apis/audit/audit";
import access from "config/access";
import HistoryTable from "components/Table/History/HistoryTable";
import Loader from "components/Loader/Loader";

// material-ui
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";

// material-ui icons
import MenuIcon from "@material-ui/icons/Menu";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HistoryIcon from "@material-ui/icons/History";
import { useTranslation } from 'react-i18next';

export default function CustomDashboard(props) {
  const { state, dispatch } = useContext(Context);
  const { getSettings } = settingsApi();
  const { getAudit } = AuditAPI();

  const [data, setdata] = useState([]);
  const history = useHistory();
  const classes = Styles();
  const { t, i18n } = useTranslation();
  const [states, setstates] = useState({ historyLoader: false });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  // handling api calls
  useEffect(() => {
    getDetails();
  }, []);

  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Settings"],
    });
  }, []);

  // settings api func
  const getDetails = async () => {
    try {
      let res = await getSettings();
      if (res) {
        setdata(res.data);
        return res;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleGetHistoryData = async (id) => {
    try {
      let values;
      values = {
        recordId: id,
        key: "hdr",
      };
      let res = await getAudit(values);
      if (res) {
        setStates({ historyData: res?.data, historyLoader: false });
      }
    } catch (e) {
      console.log({ e });
    }
  };



  const onewebAccessTypes = {
    'RESTRICTED': 'None',
    'ALLOWED': 'All',
    'PARTIALLY_ALLOWED': 'Partial',
  }

  return (
    <React.Fragment>
      <div className={classes.firstDiv}>
        <div className={classes.secondDiv}>{t('Loyalty Configurations')}</div>
      </div>
      <React.Fragment>
        <Grid container className={classes.root}>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Points to Dollar') + ' $'}</div>
              <div className={classes.values}>{data.points_to_dollar || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Qualified purchase days')} </div>
              <div className={classes.values}>
                {data.qualified_purchase_days || '-'}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Account lock attempt')} </div>
              <div className={classes.values}>{data.account_lock_attempt || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Expiring points in days')}</div>
              <div className={classes.values}>
                {data.expiring_points_in_days || '-'}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Default redemption')}</div>
              <div className={classes.values}>{data.default_redemption || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Max redemption points')}</div>
              <div className={classes.values}>{data.max_redemption_points || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Is Active')}</div>
              <div className={classes.values}>{data.is_active?.toString() || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Tier execution date')}</div>
              <div className={classes.values}>{data.tier_execution_date || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Max merch cron job')}</div>
              <div className={classes.values}>{data.max_merch_cron_job?.toString() || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Loyalty start value')}</div>
              <div className={classes.values}>{data.loyalty_start_value || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Loyalty current value')}</div>
              <div className={classes.values}>{data.loyalty_current_value || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Admin consent token expiration')}</div>
              <div className={classes.values}>{data.admin_consent_token_expiration || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Login token expiration')}</div>
              <div className={classes.values}>{data.login_token_expiration || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Signup token expiration')}</div>
              <div className={classes.values}>{data.signup_token_expiration || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Promotion current value')}</div>
              <div className={classes.values}>{data.promotion_current_value || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Cookie expiration')}</div>
              <div className={classes.values}>{data.cookie_expiration || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Banner start date')}</div>
              <div className={classes.values}>{data.banner_start_date || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Banner end date')}</div>
              <div className={classes.values}>{data.banner_end_date || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Blob sas token')}</div>
              <div className={classes.values}>{data.blob_sas_token || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Loyalty organization name')}</div>
              <div className={classes.values}>{data.loyalty_organization_name || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Loyalty site id')}</div>
              <div className={classes.values}>{data.loyalty_site_id || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Oneweb Login Access')}</div>
              <div className={classes.values}>{onewebAccessTypes[data.oneweb_login_access] || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Oneweb Enrollment Access')}</div>
              <div className={classes.values}>{onewebAccessTypes[data.oneweb_enrollment_access] || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Negative Points Mail Sender')}</div>
              <div className={classes.values}>{data?.negative_points_active_status?.toString() || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Signature Minimum Date')}</div>
              <div className={classes.values}>
                {data.min_signature_date || '-'}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Unconsented Deactivation Is Active')}</div>
              <div className={classes.values}>{data.unconsented_deactivation_is_active?.toString() || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Unconsented Deactivation Days')}</div>
              <div className={classes.values}>
                {data.unconsented_deactivation_days || '-'}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('User Password Reuse Limit')}</div>
              <div className={classes.values}>
                {data.user_password_reuse_limit || '-'}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('User Password Expiraion Days')}</div>
              <div className={classes.values}>
                {data.user_password_expiration_days || '-'}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Activation_Remainder Mail Sender')}</div>
              <div className={classes.values}>{data?.activation_remainder?.toString() || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Allow_Redemption')}</div>
              <div className={classes.values}>{data?.allow_redemption?.toString() || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Thrive Rewards Minimum Date')}</div>
              <div className={classes.values}>
                {data.min_thrive_back_date || '-'}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Annual Statement Mail Sender Date')}</div>
              <div className={classes.values}>{data.annual_statement_mail_sender_date || '-'}</div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Signature Statement Month')}</div>
              <div className={classes.values}>
                {data.signature_statement_month || '-'}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Dormant Account')}</div>
              <div className={classes.values}>
                {data.dormant_account || '-'}
              </div>
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Dormant Reminder')}</div>
              <div className={classes.values}>
                {data?.dormant_reminder?.toString() || '-'}
              </div>
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('GEP Signup API')}</div>
              <div className={classes.values}>
                {data?.is_gep_signup_api_enabled?.toString() || '-'}
              </div>
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('GEP Login API')}</div>
              <div className={classes.values}>
                {data?.is_gep_login_api_enabled?.toString() || '-'}
              </div>
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('GEP Points Balance API')}</div>
              <div className={classes.values}>
                {data?.is_gep_points_balance_api_enabled?.toString() || '-'}
              </div>
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Enable_gep_sync')}</div>
              <div className={classes.values}>
                {data?.enable_gep_sync?.toString() || '-'}
              </div>
            </div>
          </Grid>

          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('GEP Response')}</div>
              <div className={classes.values}>
                {data?.is_gep_response_enabled?.toString() || '-'}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('GEP Redirection Enable')}</div>
              <div className={classes.values}>
                {data?.is_gep_redirection_link_enabled?.toString() || '-'}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Email Count')}</div>
              <div className={classes.values}>
                {data.email_count || '-'}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Content')}</div>
              <div className={classes.values}>
                {data.content || '-'}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('TR Activation Remainder US')}</div>
              <div className={classes.values}>
                {data?.activation_remainder_US?.toString() || '-'}
              </div>
            </div>
          </Grid>
          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
            <Grid xs={12} sm={4} lg={4}>
              <div className={classes.gridDiv}>
                <div className={classes.fieldName}>{t('HSD Sync')}</div>
                <div className={classes.values}>
                  {data?.HSD_Sync?.toString() || '-'}
                </div>
              </div>
            </Grid>
          ) : null}
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Google Analytics Start Date')}</div>
              <div className={classes.values}>
                {data?.google_analytics_start_date?.toString() || '-'}
              </div>
            </div>
          </Grid>
          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
            <Grid xs={12} sm={4} lg={4}>
              <div className={classes.gridDiv}>
                <div className={classes.fieldName}>{t('Quarter End Date')}</div>
                <div className={classes.values}>
                  {data?.quarter_end_date?.toString() || '-'}
                </div>
              </div>
            </Grid>
          ) : null}

          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
            <Grid xs={12} sm={4} lg={4}>
              <div className={classes.gridDiv}>
                <div className={classes.fieldName}>{t('Dormant Reason')}</div>
                <div className={classes.values}>
                  {data.dormant_reason || '-'}
                </div>
              </div>
            </Grid>
          ) : null}

          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
            <Grid xs={12} sm={4} lg={4}>
              <div className={classes.gridDiv}>
                <div className={classes.fieldName}>{t('Startup Ratio')}</div>
                <div className={classes.values}>
                  {data.startup_ratio || '-'}
                </div>
              </div>
            </Grid>
          ) : null}

          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
            <Grid xs={12} sm={4} lg={4}>
              <div className={classes.gridDiv}>
                <div className={classes.fieldName}>{t('Startup First Date')}</div>
                <div className={classes.values}>
                  {data.startup_first_date || '-'}
                </div>
              </div>
            </Grid>
          ) : null}

          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
            <Grid xs={12} sm={4} lg={4}>
              <div className={classes.gridDiv}>
                <div className={classes.fieldName}>{t('Startup Auto Redemption')}</div>
                <div className={classes.values}>
                  {data?.auto_redemption_flag?.toString() || '-'}
                </div>
              </div>
            </Grid>
          ) : null}

           {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Earn Flag')}</div>
              <div className={classes.values}>
                {data?.Earn_Flag?.toString() || '-'}
              </div>
            </div>
          </Grid>):null}
          
          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Recurring_Flag')}</div>
              <div className={classes.values}>
                {data?.Recurring_Flag?.toString() || '-'}
              </div>
            </div>
          </Grid>):null}

          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
            <Grid xs={12} sm={4} lg={4}>
              <div className={classes.gridDiv}>
                <div className={classes.fieldName}>{t('Backdate Mail Sender Flag')}</div>
                <div className={classes.values}>
                  {data?.backdate_mail_sender_flag?.toString() || '-'}
                </div>
              </div>
            </Grid>
          ) : null}

        {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
                    <Grid xs={12} sm={4} lg={4}>
                      <div className={classes.gridDiv}>
                        <div className={classes.fieldName}>{t('Billing Amount')}</div>
                       <div className={classes.values}>{data.billing_amount || '-'}</div>
                       
                      </div>
                    </Grid>
                  ) : null}
          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
                    <Grid xs={12} sm={4} lg={4}>
                      <div className={classes.gridDiv}>
                        <div className={classes.fieldName}>{t('Unlock Minimum Date')}</div>
                       <div className={classes.values}>{data.unlock_backdate || '-'}</div>
                       
                      </div>
                    </Grid>
                  ) : null}

          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
                    <Grid xs={12} sm={4} lg={4}>
                      <div className={classes.gridDiv}>
                        <div className={classes.fieldName}>{t('Unlock Bonus Points')}</div>
                       <div className={classes.values}>{data.unlock_bonus_points || '-'}</div>
                       
                      </div>
                    </Grid>
                  ) : null}

            {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
                                <Grid xs={12} sm={4} lg={4}>
                                  <div className={classes.gridDiv}>
                                    <div className={classes.fieldName}>{t('Billing Notification')}</div>
                                    <div className={classes.values}>
                                    {data?.billing_notification?.toString() || '-'}
                                  </div>
                                  
                                  </div>
                                </Grid>
                              ) : null}
          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
            <Grid xs={12} sm={4} lg={4}>
              <div className={classes.gridDiv}>
                <div className={classes.fieldName}>{t('Welcome Bonus Flag')}</div>
                <div className={classes.values}>
                  {data?.welcome_bonus_flag?.toString() || '-'}
                </div>
              </div>
            </Grid>
          ) : null}
          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
            <Grid xs={12} sm={4} lg={4}>
              <div className={classes.gridDiv}>
                <div className={classes.fieldName}>{t('Unlock Qualified Flag')}</div>
                <div className={classes.values}>
                  {data?.unlock_qualified_flag?.toString() || '-'}
                </div>
              </div>
            </Grid>
          ) : null}
          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
                    <Grid xs={12} sm={4} lg={4}>
                      <div className={classes.gridDiv}>
                        <div className={classes.fieldName}>{t('Unlock Qualified Amount')}</div>
                       <div className={classes.values}>{data.unlock_qualified_amount || '-'}</div>
                       
                      </div>
                    </Grid>
                  ) : null}
          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
                    <Grid xs={12} sm={4} lg={4}>
                      <div className={classes.gridDiv}>
                        <div className={classes.fieldName}>{t('Master List Amount')}</div>
                       <div className={classes.values}>{data.master_min_amount || '-'}</div>
                       
                      </div>
                    </Grid>
                  ) : null}
                  {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
            <Grid xs={12} sm={4} lg={4}>
              <div className={classes.gridDiv}>
                <div className={classes.fieldName}>{t('Growth Bonus Customer Email Flag')}</div>
                <div className={classes.values}>
                  {data?.growth_bonus_customer_email_flag?.toString() || '-'}
                </div>
              </div>
            </Grid>
          ) : null}

          {state?.userInfo?.loyalty_organization_name === "Henry Schein Dental" ? (
            <Grid xs={12} sm={4} lg={4}>
              <div className={classes.gridDiv}>
                <div className={classes.fieldName}>{t('Growth Bonus FSC Email Flag')}</div>
                <div className={classes.values}>
                  {data?.growth_bonus_fsc_email_flag?.toString() || '-'}
                </div>
              </div>
            </Grid>
          ) : null}
                  {/* {state?.userInfo?.loyalty_organization_name === "Henry Schein Canada" ? (
            <Grid xs={12} sm={4} lg={4}>
              <div className={classes.gridDiv}>
                <div className={classes.fieldName}>{t('Bumpup Email Flag')}</div>
                <div className={classes.values}>
                  {data?.bumpup_email_flag?.toString() || '-'}
                </div>
              </div>
            </Grid>
          ) : null} */}

          <Grid xs={6} sm={6} lg={6}>
            <div className={classes.gridDiv}>
              <Button
                className={classes.editBtn}
                onClick={() => {
                  if (state?.userInfo?.editAction) {
                    history.push("/dashboard/edit-settings", { data: data });
                    return;
                  }
                  else {
                    toast.error(state.userInfo?.editAccess)
                    return;
                  }
                }}
                disabled={Object.keys(data).length === 0}
              >
                {t('Edit')}
              </Button>
            </div>
          </Grid>
          <Grid xs={6} sm={6} lg={6}>
            <div className={classes.gridDiv}>
              <Button
                className={classes.historyBtn}
                onClick={() => {
                  setStates({
                    historyDialog: true,
                    historyLoader: true,
                  });
                  handleGetHistoryData("1");
                }}
              >
                <HistoryIcon />
                &nbsp; {t('History')}
              </Button>
            </div>
          </Grid>
        </Grid>
      </React.Fragment>
      <React.Fragment>
        <div className={classes.firstDiv}>
          <div className={classes.secondDiv}>{t('Current Job Audit Log')}</div>
        </div>
        <Grid container className={classes.root}>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Daily Points Summary')}</div>
              <div className={classes.values}>
                {moment(data?.daily_points_summary).format(
                  "dddd, MMMM Do YYYY"
                )}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>
                {t('Sales Transaction Creation')}
              </div>
              <div className={classes.values}>
                {moment(data?.sales_transaction_creation).format(
                  "dddd, MMMM Do YYYY, h:mm:ss a"
                )}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4} />
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>
                {t('Credit Transaction Creation')}
              </div>
              <div className={classes.values}>
                {moment(data?.credit_transaction_creation).format(
                  "dddd, MMMM Do YYYY, h:mm:ss a"
                )}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>{t('Redeem Points Calculation')}</div>
              <div className={classes.values}>
                {moment(data?.redempoints_calculation).format(
                  "dddd, MMMM Do YYYY, h:mm:ss a"
                )}
              </div>
            </div>
          </Grid>
          <Grid xs={12} sm={4} lg={4} />
          <Grid xs={12} sm={4} lg={4}>
            <div className={classes.gridDiv}>
              <div className={classes.fieldName}>
                {t('Credit Sales Loyalty Id Mapping')}
              </div>
              <div className={classes.values}>
                {moment(data?.creditsales_loyaltyid_mapping).format(
                  "dddd, MMMM Do YYYY, h:mm:ss a"
                )}
              </div>
            </div>
          </Grid>
        </Grid>
      </React.Fragment>
      {/* history */}
      <Dialog
        aria-labelledby="simple-dialog-title"
        open={states.historyDialog}
        style={{ fontFamily: "Segoe-ui" }}
        maxWidth={false}
      >
        <div className={classes.dialogParentDiv}>
          <div
            className={classes.parentText}
            style={{
              paddingBottom: 10,
              width: states?.historyData?.length > 0 ? "100%" : 300,
            }}
          >
            {t('History')}{" "}
            <span style={{ float: "right" }}>
              <HighlightOffIcon
                style={{
                  cursor: "pointer",
                  color: "red",
                  fontSize: 35,
                }}
                onClick={() => {
                  setStates({ historyDialog: false, historyData: [] });
                }}
              />
            </span>
          </div>

          {!historyLoader ? (
            <HistoryTable
              headings={[
                "Date of Change",
                "Updated by",
                "Column Name",
                "Description",
              ]}
              data={
                states?.historyData?.length > 0 &&
                states?.historyData.map((d, i) => [
                  d?.created_at
                    ? `${moment(d?.created_at).format("YYYY-MM-DD HH:mm:ss")}`
                    : "",
                  `${d?.["User.email"]
                    ? d?.["User.email"]
                    : d?.altered_by
                      ? d?.altered_by.charAt(0).toUpperCase() +
                      d?.altered_by.slice(1).toLowerCase()
                      : "-"
                  }`,
                  d?.column_name,
                  `"${d?.old_value}" changed to "${d?.new_value}"`,
                ])
              }
              disablePagination={true}
            />
          ) : (
            <div>
              <Loader Loading={historyLoader} top={"15%"}></Loader>
            </div>
          )}
        </div>
      </Dialog>
    </React.Fragment>
  );
}
